import * as React from "react"

import { trackCollectionSearch } from "./library/tracking"
import { library } from "../../libraries"

export interface CollectionSearchBarProps {}

interface CollectionSearchBarState {
  input: string
}

export class CollectionSearchBar extends React.Component<CollectionSearchBarProps, CollectionSearchBarState> {
  constructor(props: CollectionSearchBarProps) {
    super(props)

    this.state = { input: "" }
  }

  render() {
    const s = this.state
    const p = this.props

    const search: () => void = () => {
      trackCollectionSearch(s.input)
      window.open(library().collectionSearchUrl(s.input))
    }

    return (
      <form className="form form--search search container--m align--center">
        <label htmlFor="collection-search" className="form__label search__label title--m">Zoek in de collectie <span className="sr-text">(externe link)</span></label>
        <div className="search__input-container form__item--icon left">
          <input
            id="collection-search"
            className="form__input search__input"
            type="text"
            onChange={e => this.setState({ ...this.state, input: e.currentTarget.value })}
            value={s.input}
            onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => (e.key == "Enter" ? search() : {})}
            placeholder="Thema, auteur, titel of ISBN nummer"
          />
          <button type="button" className="button button--primary button--arrow search__button" onClick={search}>
            <span className="button__label">Zoeken</span>
          </button>
          <svg className="form__icon" width="20px" height="20px" aria-hidden="true"><use xlinkHref="#icon--search-flevo" /></svg>
        </div>
      </form>
    )
  }
}

{/* TH: Added to styleguide! */}
